(function () {
    'use strict';

    var module = angular.module('uwAgenda.version', [
        'uwAgenda.global'
    ]);

})();